import { globalData } from "@olmokit/core/data";

export default function trackCollectionView() {
  const data = globalData["collection"];

  dataLayer.push({
    event: "viewdetailsEE",
    ecommerce: {
      detail: {
        products: [data],
      },
    },
  });
}
